const PARTICIPANT_LIMITS = {
    3: { min: 50, default: 200, max: 10000 },
    5: { min: 60, default: 500, max: 10000 },
    7: { min: 100, default: 1000, max: 10000 },
};

/** onlyCrystals: фиксированное число игроков и победителей (не пул кристаллов) */
export const CRYSTAL_ONLY_CATEGORY_PLAYERS = {
    3: 50,
    5: 60,
    7: 70,
};

export function getCrystalCategoryKey(category) {
    if (!category) return 3;
    const byNumber = Number(category.number);
    if (CRYSTAL_ONLY_CATEGORY_PLAYERS[byNumber] != null) return byNumber;
    const byName = Number(String(category.name ?? '').match(/\d+/)?.[0]);
    if (CRYSTAL_ONLY_CATEGORY_PLAYERS[byName] != null) return byName;
    return 3;
}

/** Игроки / победители: 50, 60, 70 */
export function getCrystalCategoryPlayers(categoryOrNumber) {
    const key = typeof categoryOrNumber === 'object'
        ? getCrystalCategoryKey(categoryOrNumber)
        : Number(categoryOrNumber);
    return CRYSTAL_ONLY_CATEGORY_PLAYERS[key] ?? 50;
}

/** Match saved promo category in crystal list (name, fuzzy name, or positions count). */
export function findCrystalCategoryForPromo(crystals, promo) {
    if (!crystals?.length || !promo) return null;

    const categoryName = String(promo?.category?.category_name || '').trim();
    if (categoryName) {
        const exact = crystals.find((c) => c.name === categoryName);
        if (exact) return exact;

        const lower = categoryName.toLowerCase();
        const fuzzy = crystals.find((c) => {
            const name = String(c.name || '').toLowerCase();
            return name === lower || name.includes(lower) || lower.includes(name);
        });
        if (fuzzy) return fuzzy;

        const nameNum = Number(categoryName.match(/\d+/)?.[0]);
        if (nameNum) {
            const byNameNum = crystals.find((c) => Number(c.number) === nameNum);
            if (byNameNum) return byNameNum;
        }
    }

    const positionsLen = promo?.category?.positions?.length;
    if (positionsLen) {
        const byPositions = crystals.find((c) => Number(c.number) === Number(positionsLen));
        if (byPositions) return byPositions;
    }

    return null;
}

/** Пул кристаллов: из defaultBudget категории (API), не из числа игроков */
export function getCrystalCategoryBudget(category) {
    if (!category) return 0;
    const budget = Number(category.defaultBudget);
    return Number.isNaN(budget) ? 0 : budget;
}

const FALLBACK = PARTICIPANT_LIMITS[3];
const WINNERS_PERCENT = 0.1;

export function getCategoryPlacesCount(category) {
    if (!category) return 3;
    const n = Number(category.number ?? category.positions?.length);
    return PARTICIPANT_LIMITS[n] ? n : 3;
}

export function getParticipantLimits(category) {
    return PARTICIPANT_LIMITS[getCategoryPlacesCount(category)] ?? FALLBACK;
}

export function getDefaultParticipantsCount(category) {
    return getParticipantLimits(category).default;
}

/** Мин. победители: max(фикс. мин категории, 10% от игроков) */
export function getMinWinnersCount(participantsCount, category) {
    const { min: floorMin } = getParticipantLimits(category);
    const tenPercentMin = Math.ceil(participantsCount * WINNERS_PERCENT);
    return Math.max(floorMin, tenPercentMin);
}

export function getDefaultWinnersCount(category) {
    return getDefaultParticipantsCount(category);
}

export function getEffectiveParticipantsCount(custom, category) {
    return custom > 0 ? custom : getDefaultParticipantsCount(category);
}

export function getEffectiveWinnersCount(custom, category) {
    return custom > 0 ? custom : getDefaultWinnersCount(category);
}

export function clampParticipantsCount(value, category) {
    const { default: min, max } = getParticipantLimits(category);
    return Math.min(Math.max(value, min), max);
}

export function formatParticipantLimit(n) {
    return Number(n).toLocaleString('en-US').replace(/,/g, ' ');
}

export function getPlayersKeyboardLabel(category) {
    const { default: min, max } = getParticipantLimits(category);
    return `Players - min ${formatParticipantLimit(min)}, max ${formatParticipantLimit(max)}`;
}

export function getWinnersKeyboardLabel(category, participantsCount) {
    const { max } = getParticipantLimits(category);
    const effectiveMin = getMinWinnersCount(participantsCount, category);
    const maxWinners = Math.min(participantsCount, max);
    return `Winners - min ${formatParticipantLimit(effectiveMin)} or ≥10% of players | max ${formatParticipantLimit(maxWinners)}`;
}

export function clampWinnersCount(value, participantsCount, category) {
    const { max } = getParticipantLimits(category);
    const minWinners = getMinWinnersCount(participantsCount, category);
    const maxWinners = Math.min(participantsCount, max);
    return Math.min(Math.max(value, minWinners), maxWinners);
}
